module.exports = __webpack_public_path__ + "r-v3/img/ico_arrowRight.77fbad43.svg";